"use client";
import { useEffect } from "react";

import { usePathname } from "next/navigation";

import clsx from "clsx";

import { log } from "shared-lib/helpers/logging/logger";
import { ClickServer } from "shared-lib/clickserver";
import getRecipe from "shared-lib/data/graphql/recipes/getRecipe";
import * as gtag from "shared-lib/gtag";
import { brand } from "shared-lib/helpers/envFunctions";
import {
  TRACKING_EVENTS,
  TRACKING_CATEGORIES,
} from "shared-lib/helpers/statsigFunctions";
import { waitForElementWithSelector } from "shared-lib/helpers/utilityFunctions";
import whenAvailable from "shared-lib/helpers/whenAvailable";

import { getChicorySchema } from "@/lib/getChicorySchema";

import "@/assets/ChicoryButton.css";

async function handleChicoryData(
  pathName: string,
  slug: string,
  title: string,
) {
  if (process.env.NEXT_PUBLIC_CHICORY_ENABLED !== "true") {
    return;
  }
  await waitForElementWithSelector("div#recipe-ingredients>ul>li");

  let chicoryScript = document.getElementById("chicorySchemaScript");

  if (!chicoryScript) {
    const newRecipeScript = document.createElement("script");
    newRecipeScript.id = "chicorySchemaScript";
    newRecipeScript.type = "application/ld+json";

    const recipe = await getRecipe({ slug });
    newRecipeScript.innerHTML = getChicorySchema(recipe);
    const body = document.querySelector("body");
    body?.appendChild(newRecipeScript);
  } else {
    const currentRecipe = JSON.parse(chicoryScript?.innerText ?? "");

    if (title !== currentRecipe.name) {
      const recipe = await getRecipe({ slug });
      chicoryScript.innerHTML = getChicorySchema(recipe);
    }
  }

  chicoryScript = document.getElementById("chicorySchemaScript");

  if (!chicoryScript) {
    return;
  }

  whenAvailable("chicory", function () {
    // window.chicory("setRecipe", brand.baseUrl + pathName);
    // TODO: should be reverted to the above line
    // https://recipes-heartlandcooking-git-feat-web-3383-expe-4d4a59-viewport.vercel.app/recipe/easy-cheesecake-bombs
    // https://recipes-recipereader-git-feat-web-3383-experime-3e4df3-viewport.vercel.app/recipe/easy-cheesecake-bombs
    // https://recipes-fussykitchen-git-feat-web-3383-experime-df6a47-viewport.vercel.app/recipe/easy-cheesecake-bombs
    // https://recipes-holyrecipe-git-feat-web-3383-experiment-11e667-viewport.vercel.app/recipe/easy-cheesecake-bombs
    // https://recipes-cookingprofessionally-git-feat-web-3383-0333c3-viewport.vercel.app/recipe/sugar-cookie-breakfast-casserole
    // https://recipes-bigrecipe-git-feat-web-3383-experiment-ebeefa-viewport.vercel.app/recipe/beach-house-coconut-shrimp
    log("brand >>> ", brand);
    if (brand.id === "fussykitchen"
      || brand.id === "holyrecipe"
      || brand.id === "recipereader") {
      window.chicory("setRecipe", window.location.href);
    } else {
      window.chicory("setRecipe", brand.baseUrl + pathName);
    }
  });
}

export default function ChicoryButton({
  title,
  slug,
}: {
  title?: string;
  slug?: string;
}) {
  const pathName = usePathname();

  useEffect(() => {
    if (!title || !slug) {
      return;
    }
    handleChicoryData(pathName, slug, title);
  }, [pathName, title, slug]);

  if (!title || !slug) {
    return null;
  }

  return (
    <>
      <div id="chicory_premium_pairings_unit" />
      <div
        key={title}
        className={clsx("chicory-order-ingredients mb-4 print:hidden ",
          brand.id === "fussykitchen" && "fussykitchen-chicory",
          brand.id === "holyrecipe" && "holyrecipe-chicory",
          brand.id === "recipereader" && "recipereader-chicory")
      }
        onClick={() => {
          gtag.event({
            action: TRACKING_EVENTS.chicory_button_click,
            category: TRACKING_CATEGORIES.interaction,
            label: title,
          });
          ClickServer.track(TRACKING_EVENTS.chicory_button_click);
        }}
      />
    </>
  );
}
